export const API_END_POINT_PRODUCT = 'http://localhost:8113/emil-product-api/rs/v1';
export const API_END_POINT_EMPLOYMENT = 'http://localhost:7124/emil-employer-api/rs/v1';
export const API_END_POINT_OFFER = 'http://localhost:8112/emil-offer-api/rs/v1';
export const API_END_POINT_USER = 'http://localhost:8114/emil-user-api/rs/v1';
export const API_END_POINT_INTEGRATION = 'http://localhost:7999/emil-integration-api/rs/v1';
export const API_END_POINT_EMAIL = 'http://localhost:8119/emil-utilities-api/rs/v1';
// export const API_END_POINT_PRODUCT = 'https://.execute-api.us-east-1.amazonaws.com/emil';
// export const API_END_POINT_EMPLOYMENT = 'https://geza.execute-api.us-east-1.amazonaws.com/emil';
// export const API_END_POINT_OFFER = 'https://ntij6.execute-api.us-east-1.amazonaws.com/emil';
